var p = /* @__PURE__ */ ((t) => (t.Up = "top", t.Left = "left", t.Right = "right", t.Down = "bottom", t))(p || {});
export {
  p as TriangleDirection
};
//# sourceMappingURL=variant.js.map
